<template>
  <div>
    <Header :logged="logged" :home="false" />
    <div class="produto-container">
      
      <div class="row">
        <div class="col-4 d-flex justify-content-center" v-for="p in produtos" v-if="p.value != ''">
          <div class="card text-center" style="width: 100%;">
            <div class="card-header">
              {{ p.text }}
            </div>
            <div class="card-body">
              <button class="btn btn-primary" @click="addCart(p)">Adicionar ao carrinho</button>
            </div>
          </div>
        </div>
      </div>
    </div>
      <footersite class="d-none d-xl-block" />
      <footersitemobile class="d-block d-xl-none"/>
  </div>
</template>

<script>
import Header from '../components/Header'
import footersite from "../components/footersite";
import footersitemobile from "../components/footersite/index_mobile";
import tutoriaisrelacionados from "../components/tutoriais_relacionados";
import BeatLoader from 'vue-spinner/src/BeatLoader.vue';
import API from '../services/api'


export default {
  components: {
    Header,
    footersite,
    footersitemobile,
    tutoriaisrelacionados,
    BeatLoader,

  },
  data() {
    return {
      loading:false,
      logged:false,
      mobile: window.innerWidth < 1200,
      expandMenu: false,
      produtos: [],
    }
  },
  mounted() {
    this.$root.isLogged().then((res) => {
      this.logged = true;
      this.loading = false;
    }).catch((e) => {
      this.logged = false;
      this.loading = false;
    })
  },
  methods: {
    addCart(produto){
        this.$store.commit('cart/add', {'id': produto.value, quantidade: 1, descricao: produto.text});
        this.$toasted.show('Produto adicionado ao carrinho')
    },
    getProdutos() {
      API.get(`consulta/tipoPedido`).then(res => {
        this.produtos = res.data;
      })
    }
  },
  created() {
    this.getProdutos();
  },
  computed: {
    carrinho() {
      return this.$store.state.cart.item;
    }
  }
}
</script>

<style scoped>
  .produto-container{
    width: 100%;
    min-height: 300px;
    margin-top: 160px;
    padding: 15px;
  }
</style>